import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DataAccessPolicy, DataUsageAgreement, instanceofDataUsageAgreement } from '@mtna/pojo-consumer-ts';

@Pipe({ name: 'rdsIsDataUsageAgreement' })
export class RdsIsDataUsageAgreementPipe implements PipeTransform {
  transform(dataAccessPolicy: DataAccessPolicy | undefined): DataUsageAgreement | undefined {
    if (instanceofDataUsageAgreement(dataAccessPolicy)) {
      return dataAccessPolicy;
    } else {
      return undefined;
    }
  }
}

@NgModule({
  exports: [RdsIsDataUsageAgreementPipe],
  declarations: [RdsIsDataUsageAgreementPipe],
})
export class RdsIsDataUsageAgreementPipeModule {}
